import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
const Container = styled.div`
  border: 1px solid lightgray;
  padding: 10px;
  margin-bottom: 8px;
  background-color: ${(props) =>
    props.isDragging
      ? "rgba(14,174,186,.19)"
      : ["deliver_laboratory", "deliver_dentist"].includes(
          props.sub_status_courier
        )
      ? "white"
      : props.status === "outgoing_dentist"
      ? "rgba(246,164,9,.19)"
      : "rgba(14,174,186,.14)"};
`;
export default class Task extends React.Component {
  render() {
    return (
      <Draggable draggableId={this.props.task?.id} index={this.props.index}>
        {(provided, snapshot) => (
          <Container
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            status={this.props.task?.details?.status}
            sub_status_courier={this.props.task?.details?.sub_status_courier}
          >
            {" "}
            {this.props.task?.content}{" "}
          </Container>
        )}
      </Draggable>
    );
  }
}
